import { render, staticRenderFns } from "./storeReviews.vue?vue&type=template&id=48e1d753"
import script from "./storeReviews.vue?vue&type=script&lang=js"
export * from "./storeReviews.vue?vue&type=script&lang=js"
import style0 from "./storeReviews.vue?vue&type=style&index=0&id=48e1d753&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports